import React from 'react';
import { Banner } from '../../../../models';
import CloseButton from './CloseButton';
import styles from '../StaticBanner.module.scss';
import { InfoCircleFilled } from '@ant-design/icons';
import { handleHtmlContentLinkClick } from '../../handleHtmlContentLinkClick';

type Props = {
    banner: Banner;
    onClose: () => void;
    onLinkClick?: (url: string) => void | Promise<void>;
    previewMode?: boolean;
}

const InfoBanner: React.FC<Props> = ({ banner, onClose, onLinkClick, previewMode }) => {
    const hasText = !!(banner.text && banner.text.trim());

    return (
        <div className={styles.bannerInfo}>
            <div className={styles.contentRow}>
                <InfoCircleFilled style={{color:'#1890ff'}} />
                {hasText && (
                    <div
                        className={styles.text}
                        onClick={onLinkClick ? e => { void handleHtmlContentLinkClick(e, onLinkClick); } : undefined}
                        dangerouslySetInnerHTML={{ __html: banner.text }}
                    />
                )}
                {banner.staticHideable && !previewMode && (
                    <CloseButton onClick={onClose} inline />
                )}
            </div>
        </div>
    );
};

export default InfoBanner;
